/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import './app-fab.js';
import '../behaviors/keyboard-accessibility.js';
import {
    html,
    Polymer
} from '@polymer/polymer/polymer-legacy.js';
import {
    dom as PolymerDom
} from '@polymer/polymer/lib/legacy/polymer.dom.js';

/** 
 * `<app-currency-selector>` is useful to select currency and has ability to search currecy based on currecy name.It shows currency with full name and country flag.
 * Example
 * <app-currency-selector selected-country="{{selectedCountry}}" all-currencies={{allCurrencies}} ></app-currency-selector>
 * To change full name and country flag follow below steps:
 * 1) Open currency.js(speedboat_ui/scripts/formatter)
 * 2) Search for currency whose full name and country flag to be change
 * 3) Change value for country and image key.
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-currency-selector-demo.html
 * @summary Technical component
 */
const template = html `
    <custom-style>
        <style include="app-styles">
            .app-currency-font-size{
                font-size: var(--app-currency-font-size, inherit) !important;
            }
            .absolute-position{
                position: absolute;
                width:200px !important;
                z-index: 3;
                max-height: 319px;
                overflow: auto;
                @apply --currency-selector;
            }
            
            @media all and (-ms-high-contrast:none) {
                .absolute-position {
                    right: 16px;
                    @apply --currency-selector-IE;
                }
				:dir(rtl) .absolute-position {
                    left: 16px;
					right: auto;
                }
            }
            .padding-tb-8px{
                padding:8px 0px 8px 0px;
            }
            oe-input{
                --paper-input-container-label :{
                   font-size: var(--a-font-size-m) !important;                           
                }    
            }
            .currency-header app-fab{
               opacity: .54;
            }
            .currency-header app-fab:hover{
               opacity: 1;
            }
            ::-webkit-scrollbar {
    			width: 17px;
			}
			/* Customize Thumb */
			::-webkit-scrollbar-thumb {
				background: var(--primary-dark-color);
				border-radius: 10px;
				border: 6px solid transparent;
				background-clip: content-box;
			}
			/* Customize Track */
			::-webkit-scrollbar-track {
				border: 8px solid transparent;
				background: var(--divider-color);
				background-clip: content-box;
            }

            .card-align-center {
                @apply --card-align-center;
            }
            
            .focus:focus {
                background-color: #e0e0e0;
                outline: none;
            }
            .outlineCurrancyOffset:focus{
              outline: 2px solid var(--brand-color);
              outline-offset:6px;
            }  
            .outlineOffset:focus{
              outline: 2px solid var(--brand-color);
            } 
            .card-align-top{
                top:46px;
            }
            .card-align-desk[desktop]{
                right:0px !important
            }
        </style>
    </custom-style>
        <!-- while changing arrangement of divs please check _showCurrencyList once -->
        <div class="app-currency-font-size mdl-grid">
            <div tabindex="0" role$="{{_checkDisabledDropdown(hideList)}}" id="selectCountryID" on-keydown="selectCountryOnEnter" aria-label$="{{selectedCountryLabel}} {{displayLiteral('l_selectedCountryCurrency')}}" class$="outlineOffset primary-dark-text-m font-medium currency-header horizontal layout center-center {{_getDropDownStatus(popularCurrencies,allCurrencies)}}" on-tap="_showCurrencyList">
                <template is="dom-if" if="{{_checkImage(selectedCountry)}}" restamp=true>
                    <app-fab id="app_currency_selector_4" image="{{_displayImage(selectedCountry)}}" extra-extra-extra-small></app-fab>
                </template>
                <template is="dom-if" if="{{!_checkImage(selectedCountry)}}" restamp=true>
                    <app-fab id="app_currency_selector_4" name="{{selectedCountry}}" extra-extra-extra-small></app-fab>
                </template>
                &nbsp;
                <div class="mdl-cell--middle"> {{selectedCountry}}</div>
            </div>
            <template is="dom-if" if="{{!hideList}}" restamp=true id="app_currency_selector_3">
            <paper-card class="absolute-position card-align-top card-align-desk" desktop$="{{desktop}}" id="app_currency_selector_5" hidden$="{{disabledDropdown}}">
                <div class="mdl-grid">
                    <div class="mdl-cell mdl-cell--12-col">
                        <oe-input label="{{searchLabel}}" class="outlineOffset" id="selectCountryIDSearch" no-label-float value="{{filterValue}}" on-keydown="addClickOutListenerkeydown">
                            <iron-icon icon="search" prefix></iron-icon>
                        </oe-input>
                        <template is="dom-if" if="{{_checkLength(popularCurrencies)}}">
                            <div class="secondary-dark-text-xs">
                                <oe-i18n-msg msgid="l_popularCurrencies"></oe-i18n-msg>
                            </div>
                            <div>
                                <template is="dom-repeat" items="{{popularCurrencies}}" id="app_currency_selector_1" filter="_filterCurrencies" rendered-item-count="{{renderedPopularCurrencies}}">
                                    <div id="curr_{{item}}" role="option" tabindex="0" aria-label$="{{item}} {{_displayName(item)}} {{displayLiteral('l_selectedCurrencyInstruction')}}," data-args="{{renderedPopularCurrencies}},_selectCountry" ddaId$="curr-{{index}}" on-keydown="keydownAction" class="outlineOffset horizontal layout center padding-tb-8px cursor-pointer focus" on-tap="_selectCountry">
                                        <div class="flex-1">
                                            <template is="dom-if" if="{{_checkImage(item)}}">
                                                <app-fab image="{{_displayImage(item)}}" extra-extra-small></app-fab>
                                            </template>
                                            <template is="dom-if" if="{{!_checkImage(item)}}">
                                                <app-fab name="{{item}}" extra-extra-small></app-fab>
                                            </template>
                                        </div>
                                        <div class="flex-5">
                                            <span class="primary-dark-text-m font-medium">{{item}}</span>
                                            &nbsp;&nbsp;
                                            <span class="secondary-dark-text-xs">{{_displayName(item)}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template is="dom-if" if="{{_checkLength(allCurrencies)}}">
                            <div class="secondary-dark-text-xs">
                                <oe-i18n-msg msgid="l_allCurrencies"></oe-i18n-msg>
                            </div>
                            <div role="listbox">
                                <template is="dom-repeat" items="{{allCurrencies}}" id="app_currency_selector_2" filter="_filterCurrencies" rendered-item-count="{{renderedallCurrencies}}">
                                    <div  id="curr_{{item}}" role="option" tabindex="0" aria-label$="{{item}} {{_displayName(item)}} {{displayLiteral('l_selectedCurrencyInstruction')}}," data-args="{{renderedallCurrencies}},_selectCountry"  ddaId$="curr-{{index}}" on-keydown="keydownAction" class="outlineOffset horizontal layout center padding-tb-8px cursor-pointer focus" on-tap="_selectCountry">
                                        <div class="flex-1">
                                            <template is="dom-if" if="{{_checkImage(item)}}">
                                                <app-fab image="{{_displayImage(item)}}" extra-extra-small></app-fab>
                                            </template>
                                            <template is="dom-if" if="{{!_checkImage(item)}}">
                                                <app-fab name="{{item}}" extra-extra-small></app-fab>
                                            </template>
                                        </div>
                                        <div class="flex-5">
                                            <span class="primary-dark-text-m font-medium">{{item}}</span>
                                            &nbsp;&nbsp;
                                            <span class="secondary-dark-text-xs">{{_displayName(item)}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </paper-card>
            </template>
        </div>

        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
    `;

Polymer({
    is: 'app-currency-selector',
    _template: template,
    behaviors: [corpBehaviours.appCommonBehaviourChild, accessibilityBehaviours.commonFunctions],
    properties: {
        /* Flag to show dropdown or not*/
        hideList: {
            type: Boolean,
            value: true,
            notify: true
        },
        /* List of popular currencies*/
        popularCurrencies: {
            type: Array,
            value: [],
            notify: true
        },
        /* List of all currencies*/
        allCurrencies: {
            type: Array,
            value: [],
            notify: true,
            observer: "checkIfObject"
        },
        /* Value for selected country*/
        selectedCountry: {
            type: String,
            value: '',
            notify: true,
            observer: '_checkIfPresentInList'
        },
        /* Based on this value currencies get filtered*/
        filterValue: {
            type: String,
            value: '',
            notify: true,
            observer: '_renderDomRepeat'
        },
        /*Checks phone device*/
        phone: {
            type: Boolean,
            notify: true,
            observer: '_deviceChanged'
        },
        /*Checks desktop device*/
        desktop: {
            type: Boolean,
            notify: true,
            observer: '_deviceChanged'
        },
        /*Checks tablet device*/
        tablet: {
            type: Boolean,
            notify: true,
            observer: '_deviceChanged'
        },
        /*Property to check currency dropdown exists*/
        amountCurrDropdown: {
            type: Boolean,
            notify: true,
            value: false
        },
        /*Property to disable currency type dropdown*/
        disabledDropdown: {
            type: Boolean,
            notify: true,
            value: false
        },
        /* Value for selected country*/
        selectedCountryLabel: {
            type: String,
            value: '',
            notify: true
        }
    },
    /** 
     * Method that checks allCurrencies Array is an array of objects
     **/
    checkIfObject: function() {
        //If the allCurrencies Array is an array of objects
        if (!_.isEmpty(this.allCurrencies) && this.allCurrencies.length > 0 && this.allCurrencies[0].cmCode) {
            this.allCurrencies = _.map(this.allCurrencies, _.property('cmCode'));
        }
    },
    /** 
     * Method to select country from keyboard
     * @event
     **/
    selectCountryOnEnter: function(keyboardEvent) {
        if (keyboardEvent.shiftKey && keyboardEvent.keyCode == 9) {
            if (!this.hideList) {
                this._showCurrencyList();
                this.$$("#selectCountryID").focus();
            }
        }
        if (!this.hideList && keyboardEvent.keyCode == 27) {
            this._showCurrencyList();
            this.$$("#selectCountryID").focus();
        }
        if (keyboardEvent.keyCode === 13) {
            this._showCurrencyList();
        }
    },

    ready: function() {
        this.searchLabel = getLabel("l_searchCountryCurrency");
        this.addClickOutListener = function(e) {
                var path = e.path || e.composedPath();
                var flag = false;
                for (var i = 0; i < path.length; i++) {
                    if (path[i].tagName === this.tagName) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    this.unlisten(document, 'tap', 'addClickOutListener');
                    this.hideList = true;
                }
            },
            this._showCurrencyList = function(e) {
                this.filterValue = "";
                if ((this.popularCurrencies && this.popularCurrencies.length > 1) || (this.allCurrencies && this.allCurrencies.length > 1)) {
                    this.hideList = !this.hideList;

                    if (!this.hideList) {
                        this.listen(document, 'tap', 'addClickOutListener');
                    } else {
                        this.unlisten(document, 'tap', 'addClickOutListener');
                    }
                    setTimeout(function() {
                        if (this.$$("#selectCountryIDSearch")) {
                            this.$$("#selectCountryIDSearch").inputElement.children[0].select();
                            this.listen(this.$$("#selectCountryIDSearch").inputElement.inputElement, 'blur', 'addClickOutListenerkeydown');
                        }
                    }.bind(this), 0);
                    PolymerDom(this.root).querySelector("#app_currency_selector_3").render();
                    if (PolymerDom(this).node.children[0]) {
                        var element = PolymerDom(this).node.children[0].children;
                        if (element[1] && element[1].offsetLeft + 269 > window.innerWidth) {
                            element[1].style.left = element[0].offsetLeft + element[0].clientWidth - 269;
                        }
                    }

                }


            };
        this.addClickOutListenerkeydown = function(e) {
            if (!this.hideList && e.shiftKey && e.keyCode == 9) {
                this._showCurrencyList();
                setTimeout(function() {
                    this.$$("#selectCountryID").focus();
                }.bind(this), 0);
            }
            if (!this.hideList && e.keyCode == 27) {
                this._showCurrencyList();
                this.$$("#selectCountryID").focus();
            }
        }
        this._selectCountry = function(e) {
            this.selectedCountry = e.model.item;
            if (currency && currency.settings && currency.settings.symbols && currency.settings.symbols[this.selectedCountry] && currency.settings.symbols[this.selectedCountry].country)
                this.selectedCountryLabel = currency.settings.symbols[this.selectedCountry].country;
            else {
                this.selectedCountryLabel = this.selectedCountry;
            }
            setTimeout(function() {
                this.$$("#selectCountryID").focus();
                //this.$$("#selectCountryID").setAttribute("style", "outline: 2px solid var(--brand-color);");
            }.bind(this), 0);
            this._showCurrencyList();
        }
    },
    /** 
     * Method to handle keydown action
     * @event
     **/
    keydownAction: function(e) {
        if (e.keyCode === 9) {
            if (e.model.renderedallCurrencies - 1 === e.model.index) {
                e.target.parentNode.children[0].focus();
            } else {
                this._showCurrencyList(e);
            }
        }
        if (e.keyCode === 27) {
            this._showCurrencyList();
            this.$$("#selectCountryID").focus();
        }
        //For down Arrow
        if (e.keyCode === 40) {
            if (e.model.renderedallCurrencies - 1 === e.model.index) {
                e.target.parentNode.children[0].focus();
            } else {
                e.target.nextElementSibling.focus();
            }
        }
        if (e.keyCode === 38) {
            //For up Arrow
            if (e.currentTarget.previousElementSibling) {
                e.currentTarget.previousElementSibling.focus();
            } else {
                // e.target.parentNode.children[e.target.parentNode.childElementCount - 2].focus();
                e.currentTarget.parentElement.lastElementChild.previousElementSibling.focus();
            }
        }
        if (e.keyCode === 13 || e.keyCode === 32) {
            this._selectCountry(e);
            this.$$("#selectCountryID").focus();
        }
    },
    /** 
     * Method to check length of allCurrencies and popularCurrencies greater than zero or not
     * @param {array} list
     * @return {boolean}
     **/
    _checkLength: function(list) {
        if (list && list.length > 0)
            return true;
        return false;
    },
    /** 
     * Method to display full name for currency
     * @param {object} item
     * @return {string}
     **/
    _displayName: function(item) {
        if (currency && currency.settings && currency.settings.symbols && currency.settings.symbols[item] && currency.settings.symbols[item].country)
            return currency.settings.symbols[item].country;
        return "";
    },
    /** 
     * Method to check image present for currency or not
     * @param {object} item
     * @return {boolean}
     **/
    _checkImage: function(item) {
        if (currency && currency.settings && currency.settings.symbols && currency.settings.symbols[item] && currency.settings.symbols[item].image && currency.settings.symbols[item].image != "")
            return true;
        return false;
    },
    /** 
     * Method to return image for currency
     * @param {object} item
     * @return {string}
     **/
    _displayImage: function(item) {
        if (item != undefined)
            return currency.settings.symbols[item].image;
    },
    /** 
     *  Method to filter currecies based on oe-input value
     * @param {object} item
     * @return {boolean}
     **/
    _filterCurrencies: function(item) {
        var country = "";
        if (currency && currency.settings && currency.settings.symbols && currency.settings.symbols[item] && currency.settings.symbols[item].country)
            country = currency.settings.symbols[item].country;
        return _.includes(item.toLowerCase(), this.filterValue.toLowerCase()) || _.includes(country.toLowerCase(), this.filterValue.toLowerCase());
    },
    /** 
     * Method to render popularCurrencies and allCurrencies list again
     **/
    _renderDomRepeat: function() {
        if (PolymerDom(this.root).querySelector("#app_currency_selector_1"))
            PolymerDom(this.root).querySelector("#app_currency_selector_1").render();
        if (PolymerDom(this.root).querySelector("#app_currency_selector_2"))
            PolymerDom(this.root).querySelector("#app_currency_selector_2").render();
    },
    /** 
     * Method to execute when device changed
     **/
    _deviceChanged: function() {
        if (!this.hideList)
            this.hideList = !this.hideList;
    },
    /** 
     * Method check if the selected country is present in the list of allCurrencies
     * @param {string} n
     **/
    _checkIfPresentInList: function(n) {
        if (!_.isEmpty(this.allCurrencies) && this.allCurrencies.length && !_.isEmpty(n) && this.amountCurrDropdown) {
            if (this.allCurrencies.indexOf(n) == -1) this.selectedCountry = this.allCurrencies[0];
        }
        if (currency && currency.settings && currency.settings.symbols && currency.settings.symbols[this.selectedCountry] && currency.settings.symbols[this.selectedCountry].country)
            this.selectedCountryLabel = currency.settings.symbols[this.selectedCountry].country;
        else {
            this.selectedCountryLabel = this.selectedCountry;
        }
    },
    /** 
     * Method to check dropdown is disabled or not
     * @param {boolean} val
     * @return {string}
     **/
    _checkDisabledDropdown: function(val) {
        if (val) {
            return "text"
        } else {
            return "button"
        }
    },
    /** 
     * Method to Show/hide the currency dropdown
     * @param {array} popularCurrencies
     * @param {array} allCurrencies
     * @return {string}
     **/
    _getDropDownStatus: function(popularCurrencies, allCurrencies) {
        if (popularCurrencies && popularCurrencies.length > 1 || allCurrencies && allCurrencies.length > 1) {
            return "outlineCurrancyOffset cursor-pointer focus";
        } else {
            return "";
        }
    }

});